export const COW_CDN = process.env['REACT_APP_COW_CDN'] || 'https://files.cow.fi'
